import { ContractPartnerCancellationController } from './contractPartnerCancellation.controller';
import template from './contractPartnerCancellation.html';

export const contractPartnerCancellationComponent = {
  name: 'contractPartnerCancellation',
  restrict: 'E',
  template,
  controller: ContractPartnerCancellationController,
  controllerAs: 'vm',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
};
